let megaData = {};
let megaLoaded = false;
let activeCollection = null;

/* Load everything ONCE */
async function loadMegaMenuData() {
  if (megaLoaded) return;

    console.log("Calling +++++++++");


 const collections = getProductMenuCollections();
  if (!collections.length) return;
  const left = document.getElementById('megaCollections');
  const productsContainer = document.getElementById('megaProducts');
  // const loader = document.getElementById('megaProductsLoader');

  left.innerHTML = '';
  // loader.style.display = 'flex';

  /* Fetch ALL collections products */
  await Promise.all(
    collections.map(async (col) => {
      const res = await fetch(`/collections/${col.handle}/products.json?limit=20`);
      const data = await res.json();
      megaData[col.handle] = data.products;
    })
  );

  // loader.style.display = 'none';
  megaLoaded = true;
  document.getElementById('megaMenuLoader').style.display = 'none';
  // fixHorizonSubmenuHeight();


  /* Render collections */
  collections.forEach((col, index) => {
    const div = document.createElement('div');
    div.className = 'mega-collection';
   
div.innerHTML = `
  <span class="mega-collection__text">${col.title}</span>
  <span class="mega-collection__arrow">→</span>
`;

    div.onmouseenter = () => {
      setActiveCollection(col.handle, div);
    };

    div.onclick = () => {
      window.location.href = `/collections/${col.handle}`;
    };

    left.appendChild(div);

    /* Auto activate first collection */
    if (index === 0) {
      setActiveCollection(col.handle, div);
    }
  });
}

/* Switch collection WITHOUT API call */
function setActiveCollection(handle, el) {
  if (activeCollection === handle) return;

  document.querySelectorAll('.mega-collection')
    .forEach(c => c.classList.remove('active'));

  el.classList.add('active');
  activeCollection = handle;

  renderProducts(handle);
}

/* Render products from cache */
function renderProducts(handle) {
  const container = document.getElementById('megaProducts');
  container.innerHTML = '';

  megaData[handle]?.forEach(p => {
    const a = document.createElement('a');
a.className = 'mega-product';
a.href = `/products/${p.handle}`;
a.setAttribute('aria-label', p.title);

a.innerHTML = `
  <img src="${p.images[0]?.src}" loading="lazy" alt="${p.title}" />
  <p>${p.title}</p>
`;

container.appendChild(a);

    
  });
}

/* Trigger ONLY ON FIRST HOVER */
document.querySelector('.nav-item--products')
  ?.addEventListener('mouseenter', () => {
    if (!megaLoaded) {
      loadMegaMenuData();
    }
  });


  document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.menu-list__list-item')
    .forEach(item => {
      const title = item.querySelector('.menu-list__link-title');
      if (title && title.textContent.trim() === 'Products') {
        item.addEventListener('mouseenter', () => {
          if (!megaLoaded) loadMegaMenuData();
        });
      }
    });
});


function fixHorizonSubmenuHeight() {
  const productMenuItem = [...document.querySelectorAll('.menu-list__list-item')]
    .find(item => {
      const title = item.querySelector('.menu-list__link-title');
      return title && title.textContent.trim() === 'Products';
    });

  if (!productMenuItem) return;

  const submenu = productMenuItem.querySelector('.menu-list__submenu');
  const submenuInner = productMenuItem.querySelector('.menu-list__submenu-inner');

  if (!submenu || !submenuInner) return;

  // Force Horizon to re-measure height
  requestAnimationFrame(() => {
    const height = submenuInner.scrollHeight;
    submenu.style.setProperty('--submenu-height', `${height}px`);
  });
}

function getProductMenuCollections() {
  const script = document.getElementById('productsMenuCollections');
  if (!script) return [];

  try {
    return JSON.parse(script.textContent);
  } catch (e) {
    console.error('Invalid products menu collections JSON');
    return [];
  }
}


function setHeaderHeightVar() {
  const header = document.querySelector('header, .header, .shopify-section-header');
  if (!header) return;

  const height = header.offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${height}px`);
}

document.addEventListener('DOMContentLoaded', setHeaderHeightVar);
window.addEventListener('resize', setHeaderHeightVar);